export const translations = {
  en: {
    // Header
    home: "Home",
    services: "Services",
    packages: "Packages",
    about: "About",
    contact: "Contact",
    requestCallBack: "Request Call Back",
    
    // Hero Section
    servingNizwa: "Serving Nizwa Since Years",
    heroTitle1: "Your Gateway to the World",
    heroTitle2: "& Your Guide to Oman",
    heroSubtitle: "From cutting-edge international holiday packages to authentic Omani experiences—all from the heart of Nizwa.",
    chatWhatsApp: "Chat with Us on WhatsApp",
    requestCallback: "Request a Call Back",
    licensedAgency: "Licensed Travel Agency",
    nizwaPickup: "Nizwa Pick-up Available",
    customerSupport: "24/7 Customer Support",
    
    // Services Section
    ourServices: "Our Services",
    servicesSubtitle: "Comprehensive travel solutions tailored to your needs—from international adventures to local convenience",
    
    internationalHolidays: "International Holiday Packages",
    internationalDesc: "Custom tour packages to Salalah, Dubai, Thailand, Malaysia, Singapore, and Austria",
    pickupNizwa: "Pick-up in Nizwa",
    groupTours: "Group Tours",
    customItineraries: "Customized Itineraries",
    
    hajjUmrah: "Hajj & Umrah Services",
    hajjDesc: "Complete pilgrimage packages with exceptional care and guidance",
    expertGuidance: "Expert Guidance",
    accommodation: "Accommodation",
    transportation: "Transportation",
    
    visaProcessing: "Visa Processing",
    visaDesc: "International visa assistance for tourist and business travel worldwide",
    touristVisas: "Tourist Visas",
    businessVisas: "Business Visas",
    fastProcessing: "Fast Processing",
    
    ticketingInsurance: "Ticketing & Insurance",
    ticketingDesc: "Air & bus tickets with comprehensive travel insurance plans",
    airTickets: "Air Tickets",
    busTickets: "Bus Tickets",
    travelInsurance: "Travel Insurance",
    
    localServices: "Local Services",
    localDesc: "Holiday apartments, Oman tours, and airport transfers",
    apartmentRentals: "Apartment Rentals",
    airportTransfers: "Airport Transfers",
    localTours: "Local Tours",
    
    cargoServices: "Cargo Services",
    cargoDesc: "Reliable air and sea cargo services for your shipping needs",
    airCargo: "Air Cargo",
    seaCargo: "Sea Cargo",
    doorToDoor: "Door-to-Door",
    
    specialNote: "🚗 Exclusive Nizwa Pick-up Service",
    specialNoteDesc: "Enjoy the convenience of our exclusive pick-up service in Nizwa for all group tours and packages. Travel comfortably from your doorstep!",
    
    // Callback Form
    requestCallbackTitle: "Request a Call Back",
    shareDetails: "Share your details and we'll reach out to help plan your perfect journey",
    getTouchExperts: "Get in Touch with Our Travel Experts",
    
    fullName: "Full Name",
    fullNamePlaceholder: "Enter your full name",
    phoneNumber: "Phone Number",
    phoneNumberPlaceholder: "+968 XXXX XXXX",
    serviceInterest: "Service of Interest (Optional)",
    selectService: "Select a service",
    preferredTime: "Preferred Time to Call (Optional)",
    preferredTimePlaceholder: "e.g., Morning, Afternoon, Evening",
    
    submitRequest: "Submit Request",
    submitting: "Submitting...",
    requiredFields: "* Required fields. We respect your privacy and will never share your information.",
    
    // Services dropdown
    holidayPackages: "Holiday Packages",
    hajjUmrahService: "Hajj/Umrah",
    internationalVisas: "International Visas",
    airBusTicketing: "Air/Bus Ticketing",
    travelInsuranceService: "Travel Insurance",
    localVisaServices: "Local Visa Services",
    cargoServicesOption: "Cargo Services",
    airportTransfersOption: "Airport Transfers",
    other: "Other",
    
    // Footer
    footerDesc: "Your trusted travel partner in Nizwa, offering comprehensive travel solutions from international holiday packages to local services.",
    headquarters: "Headquarters - Firq, Nizwa",
    branch: "Branch - Al Khadra, Nizwa",
    importantNotice: "Important Notice:",
    disclaimer: "Zuhoor Nizwa Travels & Tourism operates exclusively from our two locations in Firq and Al Khadra, Nizwa. We do not own or operate any branches in Seeb or any other location.",
    allRightsReserved: "Zuhoor Nizwa Travels & Tourism. All rights reserved.",
    website: "Website:",
    
    // Branch hours
    sunToThuSat: "Sun - Thu & Sat:",
    friday: "Fri:",
    
    // Contact widget
    selectBranch: "Select Branch to Call",
    chooseBranch: "Choose which branch you'd like to contact",
    firqBranch: "Firq Branch",
    khadraBranch: "Al Khadra Branch",
    call: "Call:",
    
    // Toast messages
    successTitle: "Request Submitted Successfully!",
    successDesc: "We will call you back shortly. Thank you!",
    errorTitle: "Submission Failed",
    errorDesc: "Failed to submit request. Please try again.",
    requiredFieldsError: "Required Fields Missing",
    requiredFieldsErrorDesc: "Please fill in your name and phone number.",
  },
  
  ar: {
    // Header
    home: "الرئيسية",
    services: "الخدمات",
    packages: "الباقات",
    about: "من نحن",
    contact: "اتصل بنا",
    requestCallBack: "طلب معاودة الاتصال",
    
    // Hero Section
    servingNizwa: "نخدم نزوى منذ سنوات",
    heroTitle1: "بوابتك إلى العالم",
    heroTitle2: "ودليلك في عُمان",
    heroSubtitle: "من باقات العطلات العالمية المتطورة إلى التجارب العُمانية الأصيلة - كل ذلك من قلب نزوى.",
    chatWhatsApp: "تواصل معنا عبر واتساب",
    requestCallback: "طلب معاودة الاتصال",
    licensedAgency: "وكالة سفر مرخصة",
    nizwaPickup: "خدمة التوصيل من نزوى",
    customerSupport: "دعم العملاء على مدار الساعة",
    
    // Services Section
    ourServices: "خدماتنا",
    servicesSubtitle: "حلول سفر شاملة مصممة خصيصاً لاحتياجاتك - من المغامرات الدولية إلى الراحة المحلية",
    
    internationalHolidays: "باقات العطلات الدولية",
    internationalDesc: "باقات سياحية مخصصة إلى صلالة ودبي وتايلاند وماليزيا وسنغافورة والنمسا",
    pickupNizwa: "التوصيل من نزوى",
    groupTours: "جولات جماعية",
    customItineraries: "برامج مخصصة",
    
    hajjUmrah: "خدمات الحج والعمرة",
    hajjDesc: "باقات حج وعمرة كاملة مع رعاية وإرشاد استثنائي",
    expertGuidance: "إرشاد خبير",
    accommodation: "الإقامة",
    transportation: "النقل",
    
    visaProcessing: "معالجة التأشيرات",
    visaDesc: "مساعدة في التأشيرات الدولية للسياحة والأعمال في جميع أنحاء العالم",
    touristVisas: "تأشيرات سياحية",
    businessVisas: "تأشيرات عمل",
    fastProcessing: "معالجة سريعة",
    
    ticketingInsurance: "الحجوزات والتأمين",
    ticketingDesc: "تذاكر الطيران والحافلات مع خطط تأمين سفر شاملة",
    airTickets: "تذاكر طيران",
    busTickets: "تذاكر حافلات",
    travelInsurance: "تأمين السفر",
    
    localServices: "الخدمات المحلية",
    localDesc: "شقق العطلات وجولات عُمان ونقل المطار",
    apartmentRentals: "تأجير الشقق",
    airportTransfers: "نقل المطار",
    localTours: "جولات محلية",
    
    cargoServices: "خدمات الشحن",
    cargoDesc: "خدمات شحن جوي وبحري موثوقة لاحتياجات الشحن الخاصة بك",
    airCargo: "شحن جوي",
    seaCargo: "شحن بحري",
    doorToDoor: "من الباب للباب",
    
    specialNote: "🚗 خدمة التوصيل الحصرية من نزوى",
    specialNoteDesc: "استمتع بخدمة التوصيل الحصرية من نزوى لجميع الجولات والباقات الجماعية. سافر براحة من عتبة منزلك!",
    
    // Callback Form
    requestCallbackTitle: "طلب معاودة الاتصال",
    shareDetails: "شاركنا تفاصيلك وسنتواصل معك للمساعدة في التخطيط لرحلتك المثالية",
    getTouchExperts: "تواصل مع خبراء السفر لدينا",
    
    fullName: "الاسم الكامل",
    fullNamePlaceholder: "أدخل اسمك الكامل",
    phoneNumber: "رقم الهاتف",
    phoneNumberPlaceholder: "٩٦٨ XXXX XXXX+",
    serviceInterest: "الخدمة المطلوبة (اختياري)",
    selectService: "اختر الخدمة",
    preferredTime: "الوقت المفضل للاتصال (اختياري)",
    preferredTimePlaceholder: "مثال: الصباح، الظهيرة، المساء",
    
    submitRequest: "إرسال الطلب",
    submitting: "جاري الإرسال...",
    requiredFields: "* الحقول المطلوبة. نحن نحترم خصوصيتك ولن نشارك معلوماتك أبداً.",
    
    // Services dropdown
    holidayPackages: "باقات العطلات",
    hajjUmrahService: "الحج/العمرة",
    internationalVisas: "تأشيرات دولية",
    airBusTicketing: "تذاكر الطيران/الحافلات",
    travelInsuranceService: "تأمين السفر",
    localVisaServices: "خدمات التأشيرات المحلية",
    cargoServicesOption: "خدمات الشحن",
    airportTransfersOption: "نقل المطار",
    other: "أخرى",
    
    // Footer
    footerDesc: "شريكك الموثوق في السفر في نزوى، نقدم حلول سفر شاملة من باقات العطلات الدولية إلى الخدمات المحلية.",
    headquarters: "المقر الرئيسي - فرق، نزوى",
    branch: "الفرع - الخضراء، نزوى",
    importantNotice: "إشعار هام:",
    disclaimer: "تعمل زهور نزوى للسفر والسياحة حصرياً من موقعينا في فرق والخضراء بنزوى. نحن لا نمتلك أو نشغل أي فروع في السيب أو أي موقع آخر.",
    allRightsReserved: "زهور نزوى للسفر والسياحة. جميع الحقوق محفوظة.",
    website: "الموقع الإلكتروني:",
    
    // Branch hours
    sunToThuSat: "الأحد - الخميس والسبت:",
    friday: "الجمعة:",
    
    // Contact widget
    selectBranch: "اختر الفرع للاتصال",
    chooseBranch: "اختر الفرع الذي تريد التواصل معه",
    firqBranch: "فرع فرق",
    khadraBranch: "فرع الخضراء",
    call: "اتصل:",
    
    // Toast messages
    successTitle: "تم إرسال الطلب بنجاح!",
    successDesc: "سنتصل بك قريباً. شكراً لك!",
    errorTitle: "فشل الإرسال",
    errorDesc: "فشل إرسال الطلب. يرجى المحاولة مرة أخرى.",
    requiredFieldsError: "حقول مطلوبة مفقودة",
    requiredFieldsErrorDesc: "يرجى ملء اسمك ورقم هاتفك.",
  }
};

export const getTranslation = (key, lang = 'en') => {
  return translations[lang][key] || translations.en[key] || key;
};
